import { render } from "./Home.vue?vue&type=template&id=64864bc0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=64864bc0&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64864bc0"]])

export default __exports__